import { Button, IconButton, Snackbar } from "@material-ui/core";
import { useObservable, useObservableState } from "observable-hooks";
import React from "react";
import { FiCrosshair, FiX } from "react-icons/fi";
import { useNoteUndo } from "./state/state/store";

export function UndoSnackbar() {
  const { undoState, timeoutUndo, undo } = useNoteUndo();
  const canUndo = undoState !== undefined;

  const handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    timeoutUndo();
  };

  const handleUndo = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    console.log("undo", event, reason);
    undo();
    handleClose(event, reason);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={canUndo}
      autoHideDuration={6000}
      onClose={handleClose}
      message={"Undo delete"}
      action={
        <React.Fragment>
          <Button size="small" onClick={handleUndo} color={"secondary"}>
            UNDO
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <FiX />
          </IconButton>
        </React.Fragment>
      }
    />
  );
}
